<template>
  <div class="pair-values" :class="{ horizontal }">
    <div class="main">
      <slot>
        {{ mainText || '-' }}
      </slot>
    </div>

    <div :class="{ 'text-grey-8': true, 'text-caption': true, 'q-pl-sm': horizontal }">
      <slot name="sub">
        {{ subText || '-' }}
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PairValues',
  props: {
    mainText: [String, Number],
    subText: [String, Number],
    horizontal: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/quasar.variables.scss';

.pair-values {
  width: 100%;

  &.horizontal {
    display: flex;
    align-items: center;
  }
}
</style>
